/* import __COLOCATED_TEMPLATE__ from './action-history-list-item.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-action-history-list-item';

export default Component.extend({
  tagName: '',
  CLASS_NAME,

  /** @type {Action} */
  actionModel: null,

  /** @type {String} */
  _detailsString: computed(
    'actionModel.details',
    function() {
      const details = this.get('actionModel.details');

      if (!details) {
        return '';
      }

      // Avoid the outer brackets by just parsing the interior values
      let detailsLines = [];
      Object.keys(details).forEach((key) => {
        detailsLines.push(`${key}: ` + JSON.stringify(details[key], null, 2));
      });

      return detailsLines.join("\n");
    }
  ),

  /** @type {String} */
  _valueChangeString: computed(
    'actionModel.{field,oldValue,newValue}',
    function() {
      const field = this.get('actionModel.field');

      if (!field) {
        return '';
      }

      const oldValue = this.get('actionModel.oldValue');
      const newValue = this.get('actionModel.newValue');
      if (oldValue) {
        return `${field} changed from ${oldValue} to ${newValue}`;
      }

      return `${field} changed to ${newValue}`;
    }
  ),
});
